import { useEffect, useState } from 'react';

const useIsScrolled = () => {
    const isWindowScrolled = () => {
        return __isBrowser__ && window.scrollY !== 0;
    };
    const [isScroll, setScroll] = useState(isWindowScrolled());

    useEffect(() => {
        const handleScroll = () => {
            setScroll(isWindowScrolled());
        };
        window.addEventListener('scroll', handleScroll);
        return () => {
            window.removeEventListener('scroll', handleScroll);
        };
    }, []);
    return isScroll;
};

export default useIsScrolled;
